module.exports = __webpack_public_path__ + "img/imprimaxTex.ca67b0e1.jpg";